import ActionTypes from '../action-types';

const initialState = {
  dashboardMessage: null
};

export default (state = initialState, action = {}) => {
  const { payload, type } = action;

  switch (type) {
    case ActionTypes.SET_APPLICATION_NOTIFICATION:
      return {
        ...state,
        dashboardMessage: payload
      };

    default:
      return state;
  }
};
